import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ImCross } from "react-icons/im";
import { MdCheckCircle } from "react-icons/md";
import "./StepsGuideModal.css";

const StepsGuideModal = ({ show, onHide, onProceed }) => {
  const catalogueSteps = [
    {
      method: "Download Catalogue Method",
      steps: [
        { text: "Click the 'Download' button in the navigation menu" },
        {
          text: "Log into your account (or create one if you don't have an account)",
          link: "https://bweb-products.barodaweb.org/login",
          linkText: "Login here"
        },
        { text: "Navigate to the Download Catalogue page by clicking the button in the top right corner" },
        { text: "Filter by category, subcategory, quantity range, and price range (optional - all products will be shown if not specified)" },
        { text: "Click the 'View' button to see filtered products" },
        { text: "Select the products you want to include in your catalogue" },
        { text: "Click the 'Create Catalogue' button" },
        { text: "Enter your desired delivery date and click 'Create'" },
        { text: "Your catalogue will download, and our admin team will reach out to you soon" },
      ],
    },
    {
      method: "Shopping Cart Inquiry Method",
      steps: [
        { text: "Add items to your cart (minimum 50 items) from the product list" },
        { text: "Proceed to checkout (no payment required - this creates an inquiry)" },
        { text: "Our team will review your inquiry and contact you shortly" },
      ],
    },
  ];

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className="stepsGuideModal"
    >
      <div className="modalCrossBtn" onClick={onHide}>
        <ImCross />
      </div>
      <Modal.Header closeButton={false} className="stepsModalHeader">
        <Modal.Title className="stepsModalTitle">
          How to Create Catalogue / Make Product Inquiry
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="stepsModalBody">
        {catalogueSteps.map((section, sectionIndex) => (
          <div key={sectionIndex} className="stepsSection">
            <h4 className="methodTitle">{section.method}</h4>
            <ul className="stepsList">
              {section.steps.map((step, stepIndex) => (
                <li key={stepIndex} className="stepItem">
                  <span className="stepIcon">
                    <MdCheckCircle />
                  </span>
                  <span className="stepText">
                    {step.text}
                    {step.link && (
                      <>
                        {" "}
                        <a
                          href={step.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="stepLink"
                        >
                          {step.linkText}
                        </a>
                      </>
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="importantNote">
          <h5>Important Notes:</h5>
          <ul>
            <li>
              If no category or subcategory is selected, all products from all respective categories and subcategories will be considered
            </li>
            <li>
              If the start and end price is set to 0, all products will be considered regardless of price
            </li>
            <li>Minimum 50 items required for cart inquiry method</li>
            <li>Our team will contact you shortly after receiving your inquiry</li>
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer className="stepsModalFooter">
        <Button
          variant="primary"
          onClick={onProceed}
          className="closeStepsBtn"
        >
          Got It, Let's Start!
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StepsGuideModal;
